<template> 
    <div :class="timeline" class="timeline-approval-text" v-html="approval"></div>
</template>

<script>
    export default {
        name: 'Approval',
        props: ['timeline'],
        computed: {
            approval: function() {
                let approval = this.$store.getters.getApprovalCode;
                return approval && approval.length > 0
                    ? this.$store.getters.getApprovalCode
                    : this.$store.getters.getEventApprovalCode;
            },
        },
        methods: {
            htmlReplace: function(str) {
                return str.replace(/<(?:.|\n)*?>/gm, '');
            },
        }
    }
</script>

<style scoped>
    .timeline-approval-text:hover {
        text-decoration: none !important;
    }
</style>